import { render, staticRenderFns } from "./RelatorioCategoriasProdutosRank.vue?vue&type=template&id=34a44174"
import script from "./RelatorioCategoriasProdutosRank.vue?vue&type=script&lang=js"
export * from "./RelatorioCategoriasProdutosRank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports